import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { api, getToken, setToken } from "./api";
import { FullLoader } from "@/components/Common";

const AuthCtx = createContext(null);
const EMPTY = { loading: false, user: null, profiles: [] };

export function AuthProvider({ children }) {
  const [state, setState] = useState({ loading: true, user: null, profiles: [] });
  const [activeId, setActiveId] = useState(localStorage.getItem("iym_profile"));

  const refresh = useCallback(async () => {
    if (!getToken()) {
      setState(EMPTY);
      return;
    }
    try {
      const { data } = await api.get("/auth/me");
      setState({ loading: false, user: data.user, profiles: data.profiles });
    } catch {
      setToken(null);
      setState(EMPTY);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const signIn = (data) => {
    setToken(data.token);
    setState({ loading: false, user: data.user, profiles: data.profiles });
  };
  const signOut = async () => {
    try {
      await api.post("/auth/logout");
    } catch {
      /* session already invalid */
    }
    setToken(null);
    localStorage.removeItem("iym_profile");
    setState(EMPTY);
  };
  const selectProfile = (id) => {
    localStorage.setItem("iym_profile", id);
    setActiveId(id);
  };
  const activeProfile = state.profiles.find((p) => p.id === activeId) || state.profiles[0] || null;

  return (
    <AuthCtx.Provider value={{ ...state, refresh, signIn, signOut, activeProfile, selectProfile }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);

export const homeFor = (role) => (role === "admin" ? "/admin" : role === "keeper" ? "/keeper" : "/app");

export function RequireRole({ roles, children }) {
  const { loading, user } = useAuth();
  if (loading) return <FullLoader />;
  if (!user) return <Navigate to="/" replace />;
  if (!roles.includes(user.role)) return <Navigate to={homeFor(user.role)} replace />;
  return children;
}
